import { render, staticRenderFns } from "./ElTagInput.vue?vue&type=template&id=4227c72d&scoped=true"
import script from "./ElTagInput.vue?vue&type=script&lang=js"
export * from "./ElTagInput.vue?vue&type=script&lang=js"
import style0 from "./ElTagInput.vue?vue&type=style&index=0&id=4227c72d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227c72d",
  null
  
)

export default component.exports